import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Container = styled.div`
  background-color: ${colors.$ffffff};
  border-radius: 20px;
`;

export const TopImageContainer = styled.div`
  position: relative;
  height: 150px;
  overflow: hidden;
  padding-left: 0;
  margin-bottom: 4px;
  padding-top: 0;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  @media (min-width: ${breakpoints.tablet}) {
    height: 211px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    height: 231px;
  }
`;

export const ImageContainer = styled.div`
  img {
    cursor: default;
    object-fit: contain;

    @media (min-width: ${breakpoints.desktop}) {
      padding-top: 7px;
      padding-bottom: 4px;
      padding-left: 32px;
    }

    padding-left: 20px;
  }

  position: absolute;
  display: flex;
  height: 100%;
  top: 0;
`;

export const InnerContainer = styled.div`
  padding: 24px 20px 24px;

  @media (min-width: ${breakpoints.tablet}) {
    padding: 32px 40px 24px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: 34px 54px 32px 54px;
  }
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: 400;
  color: ${colors.$262626};
`;

export const Title = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(30, 38)}
  text-align: center;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(42, 52)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
  }
`;

export const Subtitle = styled(Paragraph)`
  margin-top: 16px;
  font-family: ${fonts.regular};
  p{
    margin: 0;
  }
  ${pxToCssFont(20, 26)}
  text-align: center;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }
`;

export const Description = styled.div`
  div {
    margin: 0;
    margin-top: 32px;
    text-align: left;
    font-family: ${fonts.regular};
    ${pxToCssFont(18, 24)}
    margin-bottom: 16px;
  }
`;

export const SummaryTitle = styled(Paragraph)`
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)}
  font-weight: 700;

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 30)}
  }
`;

export const UserDetail = styled(Paragraph)`
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)}
  font-weight: 700;
  color: ${colors.$e60000};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(20, 28)}
  }
`;

export const LabelCta = styled(Paragraph)`
  margin-top: 16px;
  font-family: ${fonts.regular};
  ${pxToCssFont(14, 18)}
`;

export const CtaUser = styled.button`
  display: flex;
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: none;
  border-bottom: 1px solid ${colors.$262626};
  margin-top: 8px;
  color: ${colors.$262626};
  font-weight: 700;
  font-family: ${fonts.regular};
  ${pxToCssFont(16, 18)};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(18, 26)}
  }

  &:hover {
    cursor: pointer;
    color: ${colors.$e60000};
    border-bottom: 1px solid ${colors.$e60000};
  }
`;

export const Divider = styled.div<{ noBorder?: boolean }>`
  margin-top: 36px;
  border-bottom: ${({ noBorder }) => (noBorder ? 'inherit' : `1px solid ${colors.$bebebe}`)};
`;

export const OfferDetailsContainer = styled.div`
  align-content: flex-start;
  font-family: ${fonts.regular};
`;

export const OfferTitle = styled(Paragraph)`
  font-family: ${fonts.exbold};
  ${pxToCssFont(30, 38)};

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(42, 52)}
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)}
  }
`;

export const OfferTitleSmall = styled(Paragraph)`
  font-family: ${fonts.regular};
  color: #262626;
  font-weight: 700;
  margin-top: 32px;
  ${pxToCssFont(18, 18)};

  `;
